export function formattedProjectForDeductions(projects, activeId) {
  return projects.map(project => {
    return {
      id: project.id,
      name: project.name,
      label: activeId === project.id ? 'used.for.deductions' : 'can.choose',
      description: project.name,
      active: activeId === project.id,
      attachment: project.attachment,
    };
  });
}
